var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../framework/Framework';
export class ImageCropper {
    constructor(HTMLelement, automaticIdentification) {
        this.HTMLelement = HTMLelement;
        this.automaticIdentification = automaticIdentification;
        this.dragging = false;
        this.resizing = false;
        this.currentHandle = null;
        $(window).on('resize', () => {
            this.image.trigger('load');
        });
        $('#modal-crop-validate').on('click', () => __awaiter(this, void 0, void 0, function* () {
            const uniformisedRect = {
                x: this.rect.x / this.imageWidth,
                y: this.rect.y / this.imageHeight,
                width: this.rect.width / this.imageWidth,
                height: this.rect.height / this.imageHeight
            };
            console.log(uniformisedRect);
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'automatic_identification_image_crop',
                    session_id: this.automaticIdentification.sessionID,
                    file: this.filename,
                    rect: JSON.stringify(uniformisedRect)
                },
                dataType: 'json'
            });
            console.log(response);
            this.automaticIdentification.updateImage(this.filename, response.filename);
        }));
    }
    init(filename) {
        this.filename = filename;
        this.image = $.parseHTML(`<img src="${window.location.origin}/wp-content/uploads/automatic-identification/${this.automaticIdentification.sessionID}/${filename}" alt="" class="crop-image"/>`);
        this.image.on('load', (even, image) => {
            this.HTMLelement.get(0).style.width = '';
            this.HTMLelement.get(0).style.width = '';
            this.imageWidth = image.clientWidth;
            this.imageHeight = image.clientHeight;
            this.HTMLelement.get(0).style.width = image.clientWidth + 'px';
            this.HTMLelement.get(0).style.height = image.clientHeight + 'px';
            const containerWidth = this.HTMLelement.get(0).clientWidth;
            const containerHeight = this.HTMLelement.get(0).clientHeight;
            const size = Math.min(containerWidth, containerHeight);
            this.rect = {
                x: (containerWidth - size) / 2,
                y: (containerHeight - size) / 2,
                width: size,
                height: size
            };
            if ($('.crop-container-rect').length > 0)
                $('.crop-container-rect').get(0).parentNode.removeChild($('.crop-container-rect').get(0));
            this.createElements();
            this.addEventListeners();
            this.updateRect();
        });
        this.HTMLelement.empty().append(this.image);
    }
    createElements() {
        this.rectElement = $.parseHTML('<div class="crop-container-rect"></div>');
        this.HTMLelement.append(this.rectElement);
        this.handles = {};
        ['tl', 'tr', 'bl', 'br' /*, 't', 'b', 'l', 'r'*/].forEach(handle => {
            const handleElement = $.parseHTML(`<div class="crop-container-handle crop-container-handle-${handle}"></div>`);
            this.rectElement.append(handleElement);
            this.handles[handle] = handleElement;
        });
    }
    updateRect() {
        const { x, y, width, height } = this.rect;
        this.rect.x = Math.max(0, Math.min(this.HTMLelement.get(0).clientWidth - width, x));
        this.rect.y = Math.max(0, Math.min(this.HTMLelement.get(0).clientHeight - height, y));
        this.rect.width = Math.max(20, Math.min(this.HTMLelement.get(0).clientWidth - this.rect.x, width));
        this.rect.height = Math.max(20, Math.min(this.HTMLelement.get(0).clientHeight - this.rect.y, height));
        this.rectElement.get(0).style.transform = `translate(${this.rect.x}px, ${this.rect.y}px)`;
        this.rectElement.get(0).style.width = `${this.rect.width}px`;
        this.rectElement.get(0).style.height = `${this.rect.height}px`;
    }
    addEventListeners() {
        this.rectElement.on(['mousedown', 'touchstart'], (event) => this.onMouseDown(event));
        $('body').on(['mousemove', 'touchmove'], (event) => this.onMouseMove(event));
        $('body').on(['mouseup', 'touchend'], () => this.onMouseUp());
        Object.entries(this.handles).forEach(([key, handle]) => {
            handle.on(['mousedown', 'touchstart'], (event) => this.onHandleMouseDown(event, key));
        });
    }
    onMouseDown(event) {
        event.preventDefault();
        if (!this.currentHandle) {
            const clientX = event.clientX || event.touches[0].clientX;
            const clientY = event.clientY || event.touches[0].clientY;
            this.dragging = true;
            this.offsetX = clientX - this.rect.x;
            this.offsetY = clientY - this.rect.y;
        }
    }
    onHandleMouseDown(event, handle) {
        event.preventDefault();
        this.resizing = true;
        this.currentHandle = handle;
    }
    onMouseMove(event) {
        if (!this.dragging && !this.resizing)
            return;
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        if (this.dragging) {
            this.rect.x = clientX - this.offsetX;
            this.rect.y = clientY - this.offsetY;
            this.updateRect();
        }
        else if (this.resizing) {
            this.resizeRect(clientX - this.HTMLelement.get(0).getBoundingClientRect().left, clientY - this.HTMLelement.get(0).getBoundingClientRect().top);
            this.updateRect();
        }
    }
    onMouseUp() {
        if (this.resizing || this.dragging) {
            this.resizing = false;
            this.dragging = false;
            this.currentHandle = null;
        }
    }
    resizeRect(mouseX, mouseY) {
        const { x, y, width, height } = this.rect;
        const oldRect = Object.assign({}, this.rect);
        let newWidth, newHeight, newX, newY;
        switch (this.currentHandle) {
            case "tl":
                newWidth = width + (x - mouseX);
                newHeight = height + (y - mouseY);
                // Use the smaller dimension to maintain square ratio
                const sizeTL = Math.min(newWidth, newHeight);
                this.rect.x = x + (width - sizeTL);
                this.rect.y = y + (height - sizeTL);
                this.rect.width = this.rect.height = sizeTL;
                break;
            case "tr":
                newWidth = mouseX - x;
                newHeight = height + (y - mouseY);
                // Use the smaller dimension to maintain square ratio
                const sizeTR = Math.min(newWidth, newHeight);
                this.rect.y = y + (height - sizeTR);
                this.rect.width = this.rect.height = sizeTR;
                break;
            case "bl":
                newWidth = width + (x - mouseX);
                newHeight = mouseY - y;
                // Use the smaller dimension to maintain square ratio
                const sizeBL = Math.min(newWidth, newHeight);
                this.rect.x = x + (width - sizeBL);
                this.rect.width = this.rect.height = sizeBL;
                break;
            case "br":
                newWidth = mouseX - x;
                newHeight = mouseY - y;
                // Use the smaller dimension to maintain square ratio
                const size = Math.min(newWidth, newHeight);
                this.rect.width = this.rect.height = size;
                break;
            /*case "t":
              this.rect.y = mouseY;
              this.rect.height = height + (y - mouseY);
              this.rect.width = this.rect.height;
              break;
            case "b":
              this.rect.height = mouseY - y;
              this.rect.width = this.rect.height;
              break;
            case "l":
              this.rect.x = mouseX;
              this.rect.width = width + (x - mouseX);
              this.rect.height = this.rect.width;
              break;
            case "r":
              this.rect.width = mouseX - x;
              this.rect.height = this.rect.width;
              break;*/
        }
        // If the new rectangle is outside the container, restore to the previous size
        if (this.rect.x < 0 || this.rect.y < 0 || this.rect.x + this.rect.width > this.HTMLelement.get(0).clientWidth || this.rect.y + this.rect.height > this.HTMLelement.get(0).clientHeight)
            this.rect = oldRect;
        // if ratio is not square, restore to the previous size
        if (this.rect.width !== this.rect.height)
            this.rect = oldRect;
        this.updateRect();
    }
}
